<script>
export default {
  name: "privacyPolicy"
}
</script>

<template>
  <div class="privacy-container">
    <div class="privacy-content">
      <h2>易比图工具隐私政策</h2>
      <p class="version-date"><strong>版本日期：2025年8月26日</strong></p>
      <p class="intro">本隐私政策旨在说明本公司在您使用本软件及相关服务过程中，如何收集、使用、存储和保护您的个人信息。</p>

      <h3>1. 信息收集</h3>
      <ul>
        <li><strong>注册信息</strong>：包括姓名、邮箱、联系电话等（如适用）。</li>
        <li><strong>使用数据</strong>：包括软件功能使用频率、比对任务类型、错误日志（不含比对图片内容本身）。</li>
        <li><strong>设备信息</strong>：包括操作系统类型、版本号、硬件型号等。</li>
      </ul>

      <h3>2. 信息使用</h3>
      <ul>
        <li>提供、维护和优化本软件的功能与性能。</li>
        <li>为用户提供技术支持与更新通知。</li>
        <li>在用户同意的情况下，用于发送产品资讯或营销活动信息。</li>
      </ul>

      <h3>3. 信息存储与保护</h3>
      <ul>
        <li>本公司采取符合行业标准的安全措施保护用户数据，防止未经授权的访问、披露、篡改或毁坏。</li>
        <li>除法律法规另有规定外，本公司仅在为实现本政策所述目的所必需的期限内保存用户信息。</li>
      </ul>

      <h3>4. 信息共享</h3>
      <ul>
        <li>本公司不会向第三方出售或出租用户信息。</li>
        <li>仅在以下情况下共享用户信息：
          <ul class="nested-list">
            <li>获得用户事先同意；</li>
            <li>法律法规或政府机关要求；</li>
            <li>为维护本公司合法权益所必需。</li>
          </ul>
        </li>
      </ul>

      <h3>5. 用户权利</h3>
      <ul>
        <li>用户可随时访问、更正或删除其个人信息（法律法规另有规定的除外）。</li>
        <li>用户可撤回同意，但可能会影响某些功能的使用。</li>
      </ul>

      <h3>6. 政策更新</h3>
      <ul>
        <li>本公司可能会不时更新本政策，并通过官网或其他适当方式通知用户。</li>
        <li>更新后的政策自发布之日起生效。</li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.privacy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

.privacy-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #2c3e50;
  text-align: center;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid #eee;
  font-size: 28px;
}

.version-date {
  text-align: center;
  color: #7f8c8d;
  margin-bottom: 25px;
}

.intro {
  font-size: 16px;
  margin-bottom: 30px;
  color: #5a5a5a;
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  border-left: 4px solid #409EFF;
}

h3 {
  color: #34495e;
  margin: 25px 0 15px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 20px;
}

ul {
  padding-left: 20px;
  margin-bottom: 25px;
}

li {
  margin-bottom: 10px;
  color: #555;
  position: relative;
}



.nested-list {
  margin-top: 8px;
  margin-bottom: 8px;
}


strong {
  color: #2c3e50;
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 15px;
  }

  .privacy-content {
    padding: 20px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }

  .intro {
    padding: 12px;
    font-size: 15px;
  }
}
</style>